import { z } from 'zod';

export const TeamMemberSchema = z.object({
  id: z.string(),
  name: z.string(),
  role: z.string(),
  bio: z.string().min(30),
  init: z.string().regex(/^[A-Z]{2,3}$/, 'two or three uppercase initials expected'),
});

export type TeamMember = z.infer<typeof TeamMemberSchema>;
